<script setup lang="ts">
import { onMounted, ref } from "vue";
import { QuestionInterface } from "../../../interface/QuestionInterface";
import { AxiosError } from "axios";
import { appContainer } from "../../../container";
import { ErrorResponse } from "../../../interface/ErrorInterface";
import { LoadingService } from "../../../services/loadingService";
import { CompanyService } from "../../../services/manageCompanyService";
import { ToastService } from "../../../services/toastService";
import ValidationErrorComponent from "../../../components/ValidationErrorComponent.vue";

const props = defineProps<{
  question: QuestionInterface;
  companyId: number | null;
}>();

const questionData = ref({
  question_text: "",
});

const errors = ref({
  question_text: "",
});

const validationErrors = ref<ErrorResponse>();
const loadingService = appContainer.resolve(LoadingService);
const toastService = appContainer.resolve(ToastService);
const companyService = appContainer.resolve(CompanyService);

onMounted(() => {
  questionData.value = { ...props.question };
});

const emit = defineEmits(["close", "edit"]);

function validateForm() {
  let isValid = true;

  // Reset errors
  errors.value = {
    question_text: "",
  };

  // Validate question text
  if (!questionData.value.question_text) {
    errors.value.question_text = "Question is required.";
    isValid = false;
  }

  return isValid;
}

async function editQuestion() {
  if (validateForm()) {
    const loader = await loadingService.show();
    companyService
      .editCompanyQuestion(questionData.value as QuestionInterface)
      .then(() => {
        toastService.success("Question Updated Successfully");
        emit("edit");
      })
      .catch((err) => {
        const error = err as AxiosError;
        const errorResponse = error.response?.data as ErrorResponse;
        validationErrors.value = errorResponse;
      })
      .finally(() => loader.hide());
  }
}
</script>

<template>
  <div class="modal-backdrop">
    <div class="modal fade show" id="edit-modal">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title fw-bold">Edit Question</p>
            <button
              type="button"
              class="btn-close"
              @click="emit('close')"
            ></button>
          </div>
          <ValidationErrorComponent
            v-if="validationErrors"
            :validations="validationErrors"
          ></ValidationErrorComponent>
          <form @submit.prevent="editQuestion" class="w-100 overflow-y-auto">
            <div class="modal-body">
              <div class="mb-3">
                <label for="companyQuestionText" class="form-label fw-bold"
                  >Question</label
                >
                <textarea
                  id="companyQuestionText"
                  v-model="questionData.question_text"
                  class="form-control"
                  rows="5"
                  data-cy=""
                  maxlength="250"
                ></textarea>
                <div v-if="errors.question_text" class="error mt-2 text-danger">
                  {{ errors.question_text }}
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="submit"
                class="btn btn-primary btn-sm mx-auto text-white"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.error {
  font-size: 14px;
}
</style>
